import React from 'react';
import PropTypes from 'prop-types';
import { formatDate } from 'react-day-picker-v7/moment';
import Input from './Input';

const getRangeStringFromProps = props => (
  `Start ${formatDate(props.from, props.format)} - End ${formatDate(props.to, props.format)}`
);

class Range extends Input {
  static propTypes = {
    iconSize: PropTypes.oneOf(['', 'medium']),
    format: PropTypes.string.isRequired,
    lastSelectedPreset: PropTypes.string,
  }
  static defaultProps = {
    iconSize: null,
    lastSelectedPreset: '',
  }

  getLabel() {
    const presets = this.props.presets.findAll(this.props.from, this.props.to);

    if (!presets.length) {
      return getRangeStringFromProps(this.props);
    }

    const preset = presets.find(({ label }) => label === this.props.lastSelectedPreset) || presets[0];
    return preset.label;
  }
  render() {
    return (
      <div
        className="c-input c-input--dropdown"
        value={getRangeStringFromProps(this.props)}
        {...this.getInputProps()}
        ref={(ref) => { this.el = ref; }}
        tabIndex={-1}
      >
        {this.getLabel()}
      </div>
    );
  }
}

export default Range;
